import { AutomationTabType } from "../../../../../common/utils/types/types";

export const getScheduleNestRunDatesFixedCacheKey = (
  frequency?: AutomationTabType,
) => "postUsersMeSchedulesNextRunDate_fixedCacheKey" + frequency;
